import { useEffect } from "react";
import Cancelimg from "../../assets/img/cancel-01.svg";
import styles from "./PermisssionWidget.module.css";

const PermissoWidget = ({ widgetUrl, onClose, onSuccess, onError }) => {
  useEffect(() => {
    const handleMessage = (event) => {
      const allowedOrigin =
        process.env.REACT_APP_URL_NAME === "localhost:3000"
          ? [
              "https://widget.sandbox.bankflip.io",
              "https://widget.sandbox.permisso.io",
            ]
          : ["https://widget.bankflip.io", "https://widget.permisso.io"];

      if (!allowedOrigin.includes(event?.origin)) {
        return;
      }

      const data = event?.data;

      if (data?.name === "user_requested_closure") {
        onSuccess && onSuccess(data);
        onClose && onClose();
      } else if (
        ["session_cancelled", "token_expired", "session_expired"].includes(
          data?.name
        )
      ) {
        onError && onError(data);
        onClose && onClose();
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [onClose, onSuccess, onError]);

  return (
    <div
      className={`popup-overlay wrapper-modal modal-fixed-screen ${styles.widgetOverlay}`}
    >
      <div className={styles.widgetCard}>
        <iframe
          src={widgetUrl}
          className={styles.widgetFrame}
          title="Permisso Widget"
          allow="camera; microphone; clipboard-read; clipboard-write"
        />
        <button
          type="button"
          className={styles.closeButton}
          onClick={() => onClose && onClose()}
          aria-label="Close"
        >
          <img src={Cancelimg} alt="" />
        </button>
      </div>
    </div>
  );
};

export default PermissoWidget;
